import * as Icons from './Icons';
export default Icons;
